import { TmsRouteType } from 'app/constants/tmsRouteType'
import { CountryModel } from 'app/models/timesheet/countryModel'

const POLAND_COUNTRY_CODE = 40

export const determineRouteType = (
  country: CountryModel,
  secondCountry: CountryModel,
  loading: boolean,
): TmsRouteType => {
  let type = TmsRouteType.Undefined

  if (country == null || secondCountry == null) return type

  if (country.id == secondCountry.id) {
    if (country.nationId != POLAND_COUNTRY_CODE) {
      type = TmsRouteType.Cabotage
    } else {
      type = TmsRouteType.Domestic
    }
  } else if (loading && country.nationId == POLAND_COUNTRY_CODE) {
    type = TmsRouteType.Export
  } else if (!loading && country.nationId == POLAND_COUNTRY_CODE) {
    type = TmsRouteType.Import
  } else if (loading && secondCountry.nationId == POLAND_COUNTRY_CODE) {
    type = TmsRouteType.Import
  } else if (!loading && secondCountry.nationId == POLAND_COUNTRY_CODE) {
    type = TmsRouteType.Export
  } else {
    type = TmsRouteType.CrossTrade
  }

  return type
}
